import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { ProfileService } from './services/user/profile.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home',
      adminRequired: false
    },
    // {
    //   title: 'Chat',
    //   url: '/chats/jeopardy',
    //   icon: 'chatbubbles',
    //   adminRequired: false
    // },
    {
      title: 'About',
      url: '/about',
      icon: 'help',
      adminRequired: false
    },
    {
      title: 'Manage',
      url: '/manage',
      icon: 'list',
      adminRequired: true
    },
    {
      title: 'Display',
      url: '/display',
      icon: 'tv',
      adminRequired: true
    }
  ];

  constructor(
      private platform: Platform,
      private splashScreen: SplashScreen,
      private statusBar: StatusBar,
      private profile: ProfileService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  isAdmin() {
    return this.profile.isRole("admin");
  }
}
